import DefaultParameters from './defaultParameters';
import { CRITICAL, MEDIUM, LOW } from '../congestionLevels';
import { NETWORK_CONDITION_REASON } from '../../../../helpers/networkConditionConstants';

const createCongestionLevelBasic = (customParams = {}) => {
  const params = {
    ...DefaultParameters,
    ...customParams,
  };
  return {
    getLevel({ bandwidth, audioPacketLoss, bandwidthFairThreshold }) {
      let level;
      let reason;

      if (bandwidth <= 0) {
        if (audioPacketLoss > params.packetLossCriticalThresholdMediumBw) {
          level = CRITICAL;
          reason = NETWORK_CONDITION_REASON.PACKET_LOSS;
        } else {
          level = LOW;
          reason = NETWORK_CONDITION_REASON.NONE;
        }

        return { level, reason };
      }

      if (bandwidth >= bandwidthFairThreshold) { // LOW CONGESTION ZONE
        level = LOW;
        reason = NETWORK_CONDITION_REASON.NONE;
      } else if (bandwidth >= params.bandwidthCriticalThreshold) {
      // MEDIUM BW ZONE WITH DEPENDENCY WITH PL
        if (bandwidth >= ((params.bandwidthCriticalThreshold + bandwidthFairThreshold) / 2.0)) {
          // IF IN THE HIGHER MID-BAND WITH MEDIUM BW
          if (audioPacketLoss > params.packetLossCriticalThresholdMediumBw * 2.0) {
            level = CRITICAL;
            reason = NETWORK_CONDITION_REASON.PACKET_LOSS;
          } else {
            level = MEDIUM;
            reason = NETWORK_CONDITION_REASON.BANDWIDTH;
          }
        } else if (audioPacketLoss > params.packetLossCriticalThresholdMediumBw) {
          // IF IN THE LOWER MID-BAND WITH MEDIUM BW
          level = CRITICAL;
          reason = NETWORK_CONDITION_REASON.PACKET_LOSS;
        } else {
          level = MEDIUM;
          reason = NETWORK_CONDITION_REASON.BANDWIDTH;
        }
      } else if (audioPacketLoss > params.packetLossCriticalThreshold) {
        // CRITICAL BW ZONE WITH DEPENDENCY WITH PL
        level = CRITICAL;
        reason = NETWORK_CONDITION_REASON.PACKET_LOSS;
      } else {
        level = MEDIUM;
        reason = NETWORK_CONDITION_REASON.BANDWIDTH;
      }

      if (level === undefined) { throw new Error('undefined congestion level'); }
      return { level, reason };
    },
  };
};

export default createCongestionLevelBasic;
